<div class="wrapper">
    <app-advanced-gridview
        [dataSource]="dataSource"
        [size]="size"
        [model]="filteredTableModel"
        [menuItems]="menuItems"
        [contextualMenu]="true"
        (menuClicked)="onAction($event)"
        (rowClicked)="onSelection($event)"></app-advanced-gridview>
</div>
